<style>
    .v-user-register .card {
        border: none;
        margin-bottom: 0px;
    }
</style>
<template>
    <div class="v-user-register app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="6" sm="8">
                    <b-card no-body class="mx-4">
                        <b-card-body class="p-4">

                            <div class="mb-3 text-center">
                                <img class="mb-3" style="max-width: 200px; max-height: 150px;"
                                     :src="Core.Session.Setting.getSetting('environment.ui.logoFull')">
                                <h3 class="mt-3">{{Core.Definition.getDefinition('Création de votre compte client')}}</h3>
                                <hr/>
                            </div>

                            <Request
                                    ref="request"
                                    method="POST"
                                    :onRequestSuccess="requestSuccess"
                                    :onRequestError="requestError"
                                    root="/user/register">
                                <slot slot="body">
                                    <CForm
                                            ref="form"
                                            @onSubmit="confirm"
                                            v-if="dataFormStructure.rows !== undefined"
                                            :options="{ submit: dataForm.submit }"
                                            :structure="dataFormStructure">
                                        <slot slot="emailVerification">
                                            <div class="text-center">
                                                <h5>{{Core.Definition.getDefinition('Confirmez votre adresse courriel')}}</h5>
                                                <Alert :alert="{ show: true, variant: 'light', message: Core.Definition.getDefinition('Un courriel avec un lien de confirmation à été envoyé à votre adresse courriel. Veuillez confirmer votre adresse courriel pour continuer la création de votre compte client.') }"></Alert>
                                            </div>
                                        </slot>
                                    </CForm>
                                </slot>
                            </Request>

                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    var me = null
    import CForm from '../../components/CForm'
    import Request from '../../components/Request'
    import Alert from '../../components/Alert'
    export default {
        name: 'UserRegister',
        components: {
            CForm,
            Request,
            Alert
        },
        mounted() {
            me = this
            this.displayForm(Core.User.registerStatusStepInitial)
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataRequest: {},
                dataStep: {
                  step: 1,
                  progress: 0
                },
                dataForm: {
                    submit: {
                        text: Core.Definition.getDefinition('Confirmer') + '<i class=\'fa fa-chevron-right ml-2\'></i>',
                        variant: 'primary',
                        classes: 'pull-right'
                    },
                    structures: {
                        initial: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            cards: [
                                                {
                                                    caption: Core.Definition.getDefinition('Vos coordonnées'),
                                                    options: {headerStyle: '2'},
                                                    rows: [
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'firstname'
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'lastname'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'email'
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'phone'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'address'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'country'
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'province'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'city'
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'zipcode'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            cols: [
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'password'
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    fields: [
                                                                        {
                                                                            id: 'confirmPassword'
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                            ],
                            fields: [
                                {
                                    id: 'firstname',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Prénom'),
                                    required: true
                                },
                                {
                                    id: 'lastname',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Nom de famille'),
                                    required: true
                                },
                                {
                                    id: 'email',
                                    type: 'email',
                                    label: Core.Definition.getDefinition('Adresse courriel'),
                                    required: true
                                },
                                {
                                    id: 'phone',
                                    type: 'phone',
                                    label: Core.Definition.getDefinition('Téléphone'),
                                    required: true
                                },
                                {
                                    id: 'address',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Adresse')
                                },
                                {
                                    id: 'country',
                                    type: 'country',
                                    label: Core.Definition.getDefinition('Pays'),
                                    required: false,
                                    value: {value: 'CA', label :'Canada'},
                                    onSelect: function(value, form, fieldRefs) {
                                        if (value !== null && value.value !== undefined) {
                                            fieldRefs['province'].retrieve(value.value)
                                        } else {
                                            fieldRefs['province'].dataValue = null
                                        }
                                    }
                                },
                                {
                                    id: 'province',
                                    type: 'province',
                                    value: {value: 'QC', label :'Quebec'},
                                    label: Core.Definition.getDefinition('Province'),
                                    required: false,
                                    onSelect: function() {}
                                },
                                {
                                    id: 'city',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Ville')
                                },
                                {
                                    id: 'zipcode',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Code Postal')
                                },
                                {
                                    id: 'password',
                                    type: 'password',
                                    required: true,
                                    label: Core.Definition.getDefinition('Mot de passe'),
                                    value: ''
                                },
                                {
                                    id: 'confirmPassword',
                                    type: 'password',
                                    required: true,
                                    label: Core.Definition.getDefinition('Confirmation du mot de passe'),
                                    value: ''
                                }
                            ]
                        },
                        emailVerification: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            cards: [
                                                {
                                                    key: 'emailVerification'
                                                }
                                            ]
                                        }
                                    ]
                                },
                            ],
                            fields: []
                        }
                    }
                },
                dataFormStructure: {},
            }
        },
        methods: {
            displayForm(status) {
                switch(status) {
                    case Core.User.registerStatusStepEmailVerification:
                        this.dataFormStructure = this.dataForm.structures.emailVerification
                        break
                    default:
                        this.dataFormStructure = this.dataForm.structures.initial
                        break
                }
            },
            confirm(form, fieldRefs) {
                this.$refs.request.clearArgs()
                for(let key in form) {
                    let value = form[key]
                    let field = Core.Array.findByKey(this.dataFormStructure.fields, 'id', key)
                    this.$refs.request.addArg(key, value, field.type)
                }
                this.$refs.request.request()
            },
            requestSuccess(data) {
                if (data.status !== undefined) {
                    this.displayForm(data.status)
                    this.dataForm.submit = {}
                }
            },
            requestError(data) {
            },
            login() {
                this.$router.push('/connexion')
            }
        }
    }
</script>
